
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexwYCLkOVZAZzBMXRKMGV_E4L5us_5SQocm6NVo5zDo_8Meta } from "/opt/development/izi_bi/pages/index.vue?macro=true";
import { default as login8TeUT2jlLi33LcWhSbRsyQe3X1_lMlV94QLykS3Oz_45MMeta } from "/opt/development/izi_bi/pages/login.vue?macro=true";
import { default as indexIERQ1agHbbt8_v45uC57UY2zSQBTk45zX2psgjDB6_45QMeta } from "/opt/development/izi_bi/pages/roles/index.vue?macro=true";
import { default as index8O76VbUvAvwdj_m_45UCTzr5buUQHzQwyB161bJ6DtKSgMeta } from "/opt/development/izi_bi/pages/users/index.vue?macro=true";
import { default as _91id_939EzAzka3jgzk_45M9AGVHAxo1Ym1PJ5RV8A8HQQWJ4MCoMeta } from "/opt/development/izi_bi/pages/analisa/[id].vue?macro=true";
import { default as indexDvUrzpI7Zap2sBZEcVZxRt7MGoSceIDArniWghfcJ6IMeta } from "/opt/development/izi_bi/pages/analisa/index.vue?macro=true";
import { default as _91id_93RzP2bqAW6vtKIHUs9SNLzxagCO6ILRkVwsWUmUpuu_8Meta } from "/opt/development/izi_bi/pages/dashboard/[id].vue?macro=true";
import { default as indexnHyopIt9bJzjaZKRi0tcInVaATjTLbUnm8K752dRRRQMeta } from "/opt/development/izi_bi/pages/dashboard/index.vue?macro=true";
import { default as _91id_937VYlHJ1suNR5llMlxWnBxnb5HTJR1aqhu1gZwxTTCTkMeta } from "/opt/development/izi_bi/pages/etl-proses/[id].vue?macro=true";
import { default as index07dPSp6Y4zlX9iSJzSWq6FBtqZCc_45GVyXRDw99mTOjgMeta } from "/opt/development/izi_bi/pages/etl-proses/index.vue?macro=true";
import { default as parameterT7M8pw5Z9ZqQ9hVsRA6EfJKeK2VEJTKRlFyN2K1hZxMMeta } from "/opt/development/izi_bi/pages/system/parameter.vue?macro=true";
import { default as wa_45configTU5a_OnS7eB5Y_458KYpXhts9ehfgQbnvgCV__45kxCpIAAMeta } from "/opt/development/izi_bi/pages/system/wa-config.vue?macro=true";
import { default as email_45configQh_45JYXcHb_45KwiiS_YzGennSMpsHvkG8j5GRgvSMulcwMeta } from "/opt/development/izi_bi/pages/system/email-config.vue?macro=true";
import { default as access_45tokensAvd1irEhNJE5kLpyG9sx5twZPM_450nylVVKN4ixjEkJ0Meta } from "/opt/development/izi_bi/pages/system/access-tokens.vue?macro=true";
import { default as notificationsV6HeR79LMH9qAbNWY_45L9afzK7lX3T7tCGA8k6W7QmSYMeta } from "/opt/development/izi_bi/pages/system/notifications.vue?macro=true";
import { default as connectionsvivk1s4C8PjMd24NRF9P0_45YlVYseV3gwywv9Ukb7YXgMeta } from "/opt/development/izi_bi/pages/etl-proses/connections.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/opt/development/izi_bi/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(login8TeUT2jlLi33LcWhSbRsyQe3X1_lMlV94QLykS3Oz_45MMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/development/izi_bi/pages/login.vue")
  },
  {
    name: "roles",
    path: "/roles",
    meta: { ...(indexIERQ1agHbbt8_v45uC57UY2zSQBTk45zX2psgjDB6_45QMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/roles/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(index8O76VbUvAvwdj_m_45UCTzr5buUQHzQwyB161bJ6DtKSgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/users/index.vue")
  },
  {
    name: "analisa-id",
    path: "/analisa/:id()",
    meta: { ...(_91id_939EzAzka3jgzk_45M9AGVHAxo1Ym1PJ5RV8A8HQQWJ4MCoMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/analisa/[id].vue")
  },
  {
    name: "analisa",
    path: "/analisa",
    meta: { ...(indexDvUrzpI7Zap2sBZEcVZxRt7MGoSceIDArniWghfcJ6IMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/analisa/index.vue")
  },
  {
    name: "dashboard-id",
    path: "/dashboard/:id()",
    meta: { ...(_91id_93RzP2bqAW6vtKIHUs9SNLzxagCO6ILRkVwsWUmUpuu_8Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/dashboard/[id].vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexnHyopIt9bJzjaZKRi0tcInVaATjTLbUnm8K752dRRRQMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/dashboard/index.vue")
  },
  {
    name: "etl-proses-id",
    path: "/etl-proses/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/opt/development/izi_bi/pages/etl-proses/[id].vue")
  },
  {
    name: "etl-proses",
    path: "/etl-proses",
    meta: {"middleware":"auth"},
    component: () => import("/opt/development/izi_bi/pages/etl-proses/index.vue")
  },
  {
    name: "system-parameter",
    path: "/system/parameter",
    meta: { ...(parameterT7M8pw5Z9ZqQ9hVsRA6EfJKeK2VEJTKRlFyN2K1hZxMMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/opt/development/izi_bi/pages/system/parameter.vue")
  },
  {
    name: "system-wa-config",
    path: "/system/wa-config",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/development/izi_bi/pages/system/wa-config.vue")
  },
  {
    name: "system-email-config",
    path: "/system/email-config",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/development/izi_bi/pages/system/email-config.vue")
  },
  {
    name: "system-access-tokens",
    path: "/system/access-tokens",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/development/izi_bi/pages/system/access-tokens.vue")
  },
  {
    name: "system-notifications",
    path: "/system/notifications",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/development/izi_bi/pages/system/notifications.vue")
  },
  {
    name: "etl-proses-connections",
    path: "/etl-proses/connections",
    meta: {"middleware":"auth"},
    component: () => import("/opt/development/izi_bi/pages/etl-proses/connections.vue")
  }
]